export default () => ({
  field: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
